/**
 * Resume practice-question checkout on return (payment success modal → start question).
 */
const KEY_PENDING_QUESTION = 'practice_checkout_question_id'
const KEY_CHECKOUT_SUCCESS = 'practice_checkout_payment_success'

import { consumeCheckoutFlag } from './checkoutFlagStorage'

function safeSet(key: string, value: string): void {
  try {
    if (typeof window !== 'undefined') sessionStorage.setItem(key, value)
  } catch {
    /* quota / private mode */
  }
}

function safeGet(key: string): string | null {
  try {
    return typeof window !== 'undefined' ? sessionStorage.getItem(key) : null
  } catch {
    return null
  }
}

function safeRemove(key: string): void {
  try {
    if (typeof window !== 'undefined') sessionStorage.removeItem(key)
  } catch {
    /* */
  }
}

/** Call before navigating to /checkout for a practice question. */
export function armPracticeCheckout(questionId: string): void {
  if (!questionId?.trim()) return
  safeSet(KEY_PENDING_QUESTION, questionId.trim())
  safeRemove(KEY_CHECKOUT_SUCCESS)
}

/** Call after PayU success is verified, before router.replace(returnTo). */
export function armPracticeCheckoutPaymentSuccess(): void {
  safeSet(KEY_CHECKOUT_SUCCESS, '1')
}

export function getPendingPracticeCheckoutQuestionId(): string | null {
  const id = safeGet(KEY_PENDING_QUESTION)
  return id?.trim() ? id.trim() : null
}

export function hasPracticeCheckoutPaymentSuccessPending(): boolean {
  return safeGet(KEY_CHECKOUT_SUCCESS) === '1'
}

/** Dashboard / practice page: show payment success modal once. */
export function consumePracticeCheckoutPaymentSuccess(): boolean {
  return consumeCheckoutFlag(KEY_CHECKOUT_SUCCESS)
}

export function clearPracticeCheckoutSession(): void {
  safeRemove(KEY_PENDING_QUESTION)
  safeRemove(KEY_CHECKOUT_SUCCESS)
}
